module.exports = __webpack_public_path__ + "img/drinks.3a74755c.png";